import { render } from "./EditVehicle.vue?vue&type=template&id=0d2e4c1a"
import script from "./EditVehicle.vue?vue&type=script&lang=js"
export * from "./EditVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script